<template>
  <div>
    <b-dropdown
      id="action-button"
      toggle-tag="div"
      toggle-class="p-0 bg-transparent"
      :disabled="disabled"
    >
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="$t('deliveryRequest.actions.action')"
          class="border-0"
          :disabled="disabled"
        />
      </template>

      <b-dropdown-item v-for="item in actionDropdownItems" :key="item.key">
        <span :style="{ color: item.color }">
          {{ item.label }}
        </span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

import { actionDropdownItems } from '../lib/constants/action-items'

export default {
  components: {
    McButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    actionDropdownItems() {
      return actionDropdownItems(this.$t.bind(this))
    },
  },
}
</script>
